// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//redux
import { useDispatch } from "react-redux";
import { fetchNewsletterList } from "../../../Redux/Slices/chooseKgSlice";

//Import Scss
import "./styles.scss";

//Import assets
import assets from "../../../Assets";

//Import Custom Components
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DatePicker from "../../Common/DatePicker";
import "react-datepicker/dist/react-datepicker.css";

const Newsletter = () => {
  const headerDetails = [
    { label: "S No", sortKey: false },

    {
      label: "Email",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "email",
        });
      },
    },
    {
      label: "Description",
      sortKey: false,
    },
    //   {
    //     label: "Status",
    //     sortKey: true,
    //     singleClickFunc: () => {
    //       setSortOptions({
    //         sort_by: !sortOptions.sort_by,
    //         order_by: "status",
    //       });
    //     },
    //   },
    {
      label: "Subscribed On",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "createdAt",
        });
      },
    },
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [newsletterList, setNewsletterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortOptions, setSortOptions] = useState({
    sort_by: false,
    order_by: "createdAt",
  });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchEmail, setSearchEmail] = useState("");

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleFromDate = (date) => {
    // if (date) {
    //   setFromDate(new Date(date));
    // } else {
    //   setFromDate(null);
    // }
    setFromDate(date ? new Date(date) : null);
    if (toDate && date && toDate < date) {
      setToDate(null);
    }
  };
  const handleToDate = (date) => {
    setToDate(date ? new Date(date) : null);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();

    // Extract hours and minutes
    // let hours = date.getHours();
    // const minutes = String(date.getMinutes()).padStart(2, '0');

    // Determine AM/PM and format hours
    // const ampm = hours >= 12 ? 'PM' : 'AM';
    // hours = hours % 12 || 12;

    // Format the date and time
    return `${day}/${month}/${year}`;
  };

  function formatSendDate(dateString) {
    if (dateString === "") {
      return "";
    }
    const date = new Date(dateString);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;

    // Prevent sending "1970-01-01"
    return formattedDate === "1970-01-01" ? null : formattedDate;
  }

  const getInitials = (name) => {
    const [firstName = "", lastName = ""] = name.split(" ");
    return (
      (firstName[0] || "").toUpperCase() + (lastName[0] || "").toUpperCase()
    );
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchNewsletterList({
        data: {
          page: currentPage,
          limit: "10",
          search: searchEmail,
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
          fromDate: formatSendDate(fromDate) || "",
          ...(formatSendDate(toDate) && { toDate: formatSendDate(toDate) }),
        },
        callBack: (value) => {
          console.log(value);
          setNewsletterList(value?.data?.data_list || []);
          setTotalPages(value?.data?.pageMeta?.totalPages || 1);
          setTotalCount(value?.data?.pageMeta?.total || 0);
          setIsLoading(false);
        },
      })
    );
  }, [sortOptions, currentPage, fromDate, toDate,searchEmail]);

  return (
    <div className="newsletterContainer">
      <div className="newsletterHeader">
        <p></p>        
        <p className="totalCount">
  Total count : {totalCount}
</p>
        <input
            type="text"
            placeholder="Search by email address"
            value={searchEmail}
            onChange={(e) => {
                setSearchEmail(e.target.value);
                setCurrentPage(1);
            }}
            className="searchInput"
            />

      </div>
      <div className="newsletterTableContainer">
        <NormalTable
          headerDetails={headerDetails}
          // pagination={true}
        >
          {newsletterList.length > 0
            ? newsletterList.map((list, index) => {
                return (
                  <tr className="border" key={list.id}>
                    <td
                      style={{
                        paddingLeft: "18px",
                      }}
                    >
                      {(currentPage - 1) * 10 + (index + 1)}
                    </td>
                    {/* <td>
                      <div
                        style={{
                          display: "flex",
                          gap: "3px",
                          alignItems: "center",
                        }}
                      ></div>
                    </td> */}
                    <td>{list?.email || "-"}</td>

                    <td>{list?.description || "-"}</td>

                    {/* <td>
  <span className={list?.status ? "status-active" : "status-inactive"}>
    {list?.status ? "Active" : "Inactive"}
  </span>
</td> */}

                    <td>{formatDate(list?.createdAt) || "-"}</td>
                  </tr>
                );
              })
            : " "}
        </NormalTable>
        {newsletterList.length > 0 ? (
          ""
        ) : (
          <p
            style={{
              textAlign: "center",
              fontFamily: "poppins",
              fontSize: "4vh",
            }}
          >
            {isLoading ? "Loading" : "No Data Found"}{" "}
          </p>
        )}
        {newsletterList.length > 0 ? (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        ) : (
          " "
        )}
      </div>
    </div>
  );
};

export default Newsletter;